import classnames from 'classnames';
import React from 'react';
import styles from './scrollbar-wrapper.scss';
export const ScrollbarWrapper = _ref => {
  let {
    className,
    dataHook,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    "data-hook": dataHook,
    className: classnames(styles['scrollbar-wrapper'], className)
  }, children);
};
//# sourceMappingURL=scrollbar-wrapper.js.map